import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL + "api/",
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('token');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const fileForNewsApi = createApi({
  reducerPath: 'fileForNewsApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    addAttachmentForNews: builder.mutation({
      query: (formData) => ({
        url: '/api/File/AddAttachmentForNews',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const { useAddAttachmentForNewsMutation } = fileForNewsApi;